import React from 'react';
import ImageTypeIcon from 'icons/ImageType.icon';
import WordIcon from 'icons/Word.icon';
import ExcelIcon from 'icons/Excel.icon';
import PdfIcon from 'icons/Pdf.icon';
import PowerpointIcon from 'icons/Powerpoint.icon';
import FileTypeIcon from 'icons/FileType.icon';
import FolderIcon from 'icons/Folder.icon';
import VideoIcon from 'icons/Video.icon';

type MymeTypeIconProps = {
  className?: string;
  mimeType: string;
};

const FILE_ICONS = {
  image: <ImageTypeIcon />,
  video: <VideoIcon />,
  word: <WordIcon />,
  excel: <ExcelIcon />,
  pdf: <PdfIcon />,
  ppt: <PowerpointIcon />,
  default: <FileTypeIcon />,
};

const APPLICATION_SUFIXES = {
  msword: 'word',
  'vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
  pdf: 'pdf',
  'vnd.ms-powerpoint': 'ppt',
  'vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
  'vnd.ms-excel': 'excel',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
};

const PREFIX_DETERMINED_TYPES = ['image', 'video'];

const returnIconKeyword = (mimeType: string): keyof typeof FILE_ICONS => {
  const [prefix, sufix] = mimeType.split('/');

  if (PREFIX_DETERMINED_TYPES.includes(prefix))
    return prefix as keyof typeof FILE_ICONS;

  if (
    prefix === 'application' &&
    APPLICATION_SUFIXES?.[sufix as keyof typeof APPLICATION_SUFIXES]
  ) {
    return APPLICATION_SUFIXES[
      sufix as keyof typeof APPLICATION_SUFIXES
    ] as keyof typeof FILE_ICONS;
  }

  return 'default';
};

const MymeTypeIcon: React.FC<MymeTypeIconProps> = (props) => {
  const { mimeType } = props;

  if (!mimeType) return <FolderIcon className="folder-icon" />;

  return FILE_ICONS[returnIconKeyword(mimeType)];
};

export default MymeTypeIcon;
